import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export default function PrivacyPolicyPage() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 min-h-screen bg-[#F8F6F2]" data-testid="privacy-policy-page">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 lg:p-12 shadow-sm border border-gray-100">
            <h1 
              className="text-3xl sm:text-4xl font-bold text-[#0B1C2D] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Privacy Policy
            </h1>
            <div className="w-20 h-1 bg-[#C6A34A] mb-8" />

            <div className="prose prose-gray max-w-none text-[#4A5568]">
              <p className="text-sm text-[#718096] mb-6">
                Last Updated: January 2026
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Introduction
              </h2>
              <p className="mb-4 leading-relaxed">
                This Privacy Policy describes how Chambers of Adv. Ajeet Narayan Sinha ("we," "us," or "our") 
                collects, uses, and protects information obtained through the website jurisbihar.com ("Website"). 
                By using our Website, you consent to the practices described in this policy.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Information We Collect
              </h2>
              <p className="mb-4 leading-relaxed">
                We may collect the following types of information:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li><strong>Personal Information:</strong> Name, phone number, email address, and any information you provide through our inquiry form.</li>
                <li><strong>Communication Data:</strong> Subject and description of your legal matter as submitted through the contact form.</li>
                <li><strong>Technical Data:</strong> IP address, browser type, device information, and usage statistics collected automatically.</li>
                <li><strong>Cookies:</strong> We may use cookies to enhance your browsing experience and analyze website traffic.</li>
              </ul>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                How We Use Your Information
              </h2>
              <p className="mb-4 leading-relaxed">
                The information collected is used for the following purposes:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>To respond to your inquiries and communicate with you regarding your legal queries.</li>
                <li>To improve our website and services.</li>
                <li>To maintain records of communications as required by professional guidelines.</li>
                <li>To comply with legal obligations and professional requirements.</li>
              </ul>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Information Sharing
              </h2>
              <p className="mb-4 leading-relaxed">
                We do not sell, trade, or otherwise transfer your personal information to third parties. 
                We may share information only in the following circumstances:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>With your explicit consent.</li>
                <li>To comply with legal obligations or court orders.</li>
                <li>To protect our rights and the safety of users.</li>
                <li>With service providers who assist in operating our website (under strict confidentiality).</li>
              </ul>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Data Security
              </h2>
              <p className="mb-4 leading-relaxed">
                We implement appropriate technical and organizational measures to protect your personal 
                information against unauthorized access, alteration, disclosure, or destruction. However, 
                no method of transmission over the Internet is completely secure, and we cannot guarantee 
                absolute security.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Data Retention
              </h2>
              <p className="mb-4 leading-relaxed">
                We retain your personal information only for as long as necessary to fulfill the purposes 
                outlined in this policy or as required by law. Inquiry records may be retained for 
                professional record-keeping purposes in accordance with Bar Council guidelines.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Your Rights
              </h2>
              <p className="mb-4 leading-relaxed">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Request access to the personal information we hold about you.</li>
                <li>Request correction of any inaccurate information.</li>
                <li>Request deletion of your information (subject to legal requirements).</li>
                <li>Withdraw consent for processing of your information.</li>
              </ul>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Third-Party Links
              </h2>
              <p className="mb-4 leading-relaxed">
                Our website may contain links to external websites. We are not responsible for the privacy 
                practices or content of these third-party sites. We encourage you to review the privacy 
                policies of any external websites you visit.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Changes to This Policy
              </h2>
              <p className="mb-4 leading-relaxed">
                We may update this Privacy Policy from time to time. Any changes will be posted on this 
                page with an updated revision date. We encourage you to review this policy periodically.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Contact Us
              </h2>
              <p className="mb-4 leading-relaxed">
                For any questions or concerns regarding this Privacy Policy, please contact us at:<br />
                Email: ajeet.sinha@jurisbihar.com<br />
                Phone: +91 9431078694<br />
                Address: 306, Devendra Residency, Kankarbagh Main Road, Patna, Bihar - 800026
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
